module.exports = __webpack_public_path__ + "img/FW_Phone.70b650b4.jpg";